const state = {
  isConnected: false,
  account: null,
  chainId: null,
  walletType: null,
  isConnecting: false,
  error: null,
  lastConnectionState: null,
  lastWalletType: null
};

const mutations = {
  SET_CONNECTION_STATUS(state, status) {
    state.isConnected = status;
  },
  SET_ACCOUNT(state, account) {
    state.account = account;
  },
  SET_CHAIN_ID(state, chainId) {
    state.chainId = chainId;
  },
  SET_WALLET_TYPE(state, walletType) {
    state.walletType = walletType;
  },
  SET_CONNECTING(state, status) {
    state.isConnecting = status;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  RESET_WEB3_STATE(state) {
    state.isConnected = false;
    state.account = null;
    state.chainId = null;
    state.walletType = null;
    state.isConnecting = false;
    state.error = null;
  },
  SET_LAST_CONNECTION_STATE(state, status) {
    state.lastConnectionState = status;
  },
  SET_LAST_WALLET_TYPE(state, walletType) {
    state.lastWalletType = walletType;
  }
};

const actions = {
  initWeb3State({ commit }) {
    const lastConnectionState = localStorage.getItem('web3_last_connection_state');
    const lastWalletType = localStorage.getItem('web3_wallet_type');
    
    if (lastConnectionState) {
      commit('SET_LAST_CONNECTION_STATE', lastConnectionState);
      commit('SET_LAST_WALLET_TYPE', lastWalletType);
    }
  },
  
  resetPersistentState({ commit }) {
    localStorage.removeItem('web3_last_connection_state');
    localStorage.removeItem('web3_wallet_type');
    localStorage.removeItem('web3_connected');
    localStorage.removeItem('web3_account');
    localStorage.removeItem('web3_chain_id');
    
    commit('SET_LAST_CONNECTION_STATE', null);
    commit('SET_LAST_WALLET_TYPE', null);
  },
  
  async connectWallet({ commit, dispatch }, walletType) {
    try {
      commit('SET_CONNECTING', true);
      commit('SET_ERROR', null);
      
      if (walletType === 'metamask' && typeof window.ethereum !== 'undefined') {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        if (accounts.length > 0) {
          const account = accounts[0];
          const chainId = await window.ethereum.request({ method: 'eth_chainId' });
          
          commit('SET_ACCOUNT', account);
          commit('SET_CHAIN_ID', chainId);
          commit('SET_WALLET_TYPE', walletType);
          commit('SET_CONNECTION_STATUS', true);
          commit('SET_LAST_CONNECTION_STATE', 'connected');
          commit('SET_LAST_WALLET_TYPE', walletType);
          
          localStorage.setItem('web3_connected', 'true');
          localStorage.setItem('web3_wallet_type', walletType);
          localStorage.setItem('web3_account', account);
          localStorage.setItem('web3_chain_id', chainId);
          localStorage.setItem('web3_last_connection_state', 'connected');
          
          window.ethereum.on('accountsChanged', (accounts) => {
            if (accounts.length === 0) {
              dispatch('disconnectWallet');
            } else {
              commit('SET_ACCOUNT', accounts[0]);
            }
          });
          
          window.ethereum.on('chainChanged', (chainId) => {
            commit('SET_CHAIN_ID', chainId);
          });
        }
      } else if (walletType === 'walletconnect') {
        commit('SET_ERROR', 'WalletConnect not implemented yet');
      } else if (walletType === 'coinbase') {
        if (typeof window.ethereum !== 'undefined' && window.ethereum.isCoinbaseWallet) {
          const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
          if (accounts.length > 0) {
            const account = accounts[0];
            const chainId = await window.ethereum.request({ method: 'eth_chainId' });
            
            commit('SET_ACCOUNT', account);
            commit('SET_CHAIN_ID', chainId);
            commit('SET_WALLET_TYPE', walletType);
            commit('SET_CONNECTION_STATUS', true);
            commit('SET_LAST_CONNECTION_STATE', 'connected');
            commit('SET_LAST_WALLET_TYPE', walletType);
            
            localStorage.setItem('web3_connected', 'true');
            localStorage.setItem('web3_wallet_type', walletType);
            localStorage.setItem('web3_account', account);
            localStorage.setItem('web3_chainId', chainId);
            localStorage.setItem('web3_last_connection_state', 'connected');
            
            window.ethereum.on('accountsChanged', (accounts) => {
              if (accounts.length === 0) {
                dispatch('disconnectWallet');
              } else {
                commit('SET_ACCOUNT', accounts[0]);
              }
            });
            
            window.ethereum.on('chainChanged', (chainId) => {
              commit('SET_CHAIN_ID', chainId);
            });
          }
        } else {
          commit('SET_ERROR', 'Coinbase Wallet not detected. Please install the Coinbase Wallet extension.');
        }
      }
    } catch (error) {
      commit('SET_ERROR', error.message);
      commit('SET_CONNECTION_STATUS', false);
    } finally {
      commit('SET_CONNECTING', false);
    }
  },
  
  async disconnectWallet({ commit }) {
    localStorage.setItem('web3_last_connection_state', 'disconnected');
    localStorage.removeItem('web3_connected');
    localStorage.removeItem('web3_wallet_type');
    localStorage.removeItem('web3_account');
    localStorage.removeItem('web3_chain_id');
    
    commit('SET_LAST_CONNECTION_STATE', 'disconnected');
    commit('RESET_WEB3_STATE');
  },
  
  async checkConnection({ commit, dispatch }) {
    const lastConnectionState = localStorage.getItem('web3_last_connection_state');
    
    if (lastConnectionState === 'disconnected') {
      return;
    }
    
    if (typeof window.ethereum !== 'undefined') {
      try {
        const accounts = await window.ethereum.request({ method: 'eth_accounts' });
        if (accounts.length > 0) {
          const account = accounts[0];
          const chainId = await window.ethereum.request({ method: 'eth_chainId' });
          
          let walletType = 'metamask';
          if (window.ethereum.isCoinbaseWallet) {
            walletType = 'coinbase';
          }
          
          commit('SET_ACCOUNT', account);
          commit('SET_CHAIN_ID', chainId);
          commit('SET_WALLET_TYPE', walletType);
          commit('SET_CONNECTION_STATUS', true);
          commit('SET_LAST_CONNECTION_STATE', 'connected');
          commit('SET_LAST_WALLET_TYPE', walletType);
          
          window.ethereum.on('accountsChanged', (accounts) => {
            if (accounts.length === 0) {
              dispatch('disconnectWallet');
            } else {
              commit('SET_ACCOUNT', accounts[0]);
            }
          });
          
          window.ethereum.on('chainChanged', (chainId) => {
            commit('SET_CHAIN_ID', chainId);
          });
        }
      } catch (error) {
        console.error('Error checking connection:', error);
      }
    }
  }
};

const getters = {
  isConnected: state => state.isConnected,
  account: state => state.account,
  chainId: state => state.chainId,
  walletType: state => state.walletType,
  isConnecting: state => state.isConnecting,
  error: state => state.error,
  shortAccount: state => {
    if (!state.account) return '';
    return `${state.account.slice(0, 6)}...${state.account.slice(-4)}`;
  },
  wasPreviouslyConnected: state => state.lastConnectionState === 'connected',
  lastWalletType: state => state.lastWalletType,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
